const translations = {
  clustering: 'Agrupamiento',
  showUsers: 'Mostrar usuarios',
  showPlaces: 'Mostrar locales',
  route: 'Ruta',
  selectUserAndHours: 'Seleccione el usuario y las últimas horas recorridas.',
  user: 'Usuario',
  lastHours: 'Últimas horas',
  search: 'Buscar',
  removeRoute: 'Eliminar ruta',
  selectUserError: 'Seleccione un usuario.',
  setHoursError: 'Defina la cantidad de horas.'
}

export default translations
